﻿import EnvironmentVariables from "../../EnvironmentVariables";

export interface ISignlarConstants {
    chat: {
        negotiateUrl: string,
        sendMessage: string,
    },
    general: {
        appInsightsSendToOthersError: string,
        appInsightsSendToUserByIdError: string,
        appInsightsSendToALLError: string,
        appInsightsConnectionState: string,
        appInsightsStartConnectionError: string,
    }
}

export const signalrConstants: ISignlarConstants = {
    chat: {
        negotiateUrl: EnvironmentVariables.getApimUrl() + `/signalr-azure-function/api/signalr/negotiate`,
        sendMessage: EnvironmentVariables.getApimUrl() + `/signalr-azure-function/api/signalr-send-message`
    },
    general: {
        appInsightsSendToOthersError: 'UI: Signalr-SendToOthersError',
        appInsightsConnectionState: 'UI: Signalr-ConnectionState',
        appInsightsSendToALLError: 'UI: Signalr-SendToALL-Error',
        appInsightsStartConnectionError: 'UI: Signalr-StartConnection-Error',
        appInsightsSendToUserByIdError: 'UI: Signalr-SendToUserById-Error',
    }
};
